
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'TripDetailFooterButton'
})
export default class TripDetailFooterButton extends Vue {
  @Prop({ required: true })
  private text: string;

  @Prop({ default: false })
  private danger: boolean;

  @Prop({ default: false })
  private neutral: boolean;

  @Prop({ default: false })
  private disabled: boolean;
}
